import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Bootstrap 5 base — loaded BEFORE our overrides so theme.css can
// override Bootstrap CSS variables per the AquaStar palette.
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import './styles/overrides.css';

import App from './App.tsx';
import { AuthProvider } from './lib/auth.tsx';
import { ThemeProvider } from './lib/theme.tsx';

// P1-WU06 — expose the build stamp on window for devtools console
// debugging ("what build am I looking at?"). __BUILD__ itself is
// injected by Vite at build time; see vite.config.ts and
// src/types/global.d.ts.
if (typeof window !== 'undefined') {
  window.__BUILD__ = __BUILD__;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
